import { FileTypeEnum as e } from "@systemeio/types";
import { FileTypeEnum as t } from "@systemeio/types";
const m = {
  [e.Image]: "file_manager.file_type.image",
  [e.ImageOther]: "file_manager.file_type.image_other",
  [e.Video]: "file_manager.file_type.video",
  [e.Audio]: "file_manager.file_type.audio",
  [e.Font]: "file_manager.file_type.font",
  [e.Document]: "file_manager.file_type.document"
};
export {
  t as FileTypeEnum,
  m as FileTypeEnumLocoKeys
};
